import { Typography, styled } from "@mui/material";
import writers from "../../../images/writersIcon.png";
import developers from "../../../images/developerIcon.png";
import designers from "../../../images/designerIcon.png";
import analyst from "../../../images/analystIcon.png";

const HeroSection = ({
  setOpen,
}: {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <Root>
      <MainContainer>
        <section>
          <MainText>
            <ImageOne src={developers} alt="" />
            <ImageTwo src={designers} alt="" />
            <ImageThree src={writers} alt="" />
            <ImageFour src={analyst} alt="" />
            <>
              <h1>Land Your First Freelance Client in 6 Weeks</h1>
              <PaperHeadText>
                Join our mentorship-driven internship, where veteran freelancers
                coach you while an AI-powered Agencer finds leads, writes
                pitches, and helps you close the deal.
              </PaperHeadText>
            </>
            <CtaBtnBox>
              <CtaButton onClick={() => setOpen(true)} disabled>
                Closed
              </CtaButton>
            </CtaBtnBox>
            {/* <Typography
              sx={{
                fontWeight: 500,
                fontSize: "1.25rem",
                lineHeight: "2rem",
                mt: "20px",
              }}
            >
              Apply by Jun 18 2025
            </Typography> */}
          </MainText>
        </section>
      </MainContainer>
    </Root>
  );
};

export default HeroSection;

const Root = styled("div")(({ theme }) => ({
  maxWidth: "1200px",
  margin: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  color: "#fefefe",
  textAlign: "center",

  [theme.breakpoints.down(900)]: {
    paddingTop: 16,
  },
  [theme.breakpoints.down(720)]: {
    paddingRight: 16,
    paddingLeft: 16,
  },
}));

const MainContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  [theme.breakpoints.down(900)]: {
    paddingTop: 76,
  },
}));

const ImageOne = styled("img")(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: -180,
  [theme.breakpoints.down(1200)]: {
    left: -100,
  },
  [theme.breakpoints.down(900)]: {
    left: -150,
  },
  [theme.breakpoints.down(720)]: {
    display: "none",
  },
}));
const ImageTwo = styled("img")(({ theme }) => ({
  position: "absolute",
  bottom: 0,
  left: -120,
  [theme.breakpoints.down(1200)]: {
    left: -40,
  },
  [theme.breakpoints.down(900)]: {
    left: -90,
  },
  [theme.breakpoints.down(720)]: {
    display: "none",
  },
}));
const ImageThree = styled("img")(({ theme }) => ({
  position: "absolute",
  top: 0,
  right: -180,
  [theme.breakpoints.down(1200)]: {
    right: -100,
  },
  [theme.breakpoints.down(900)]: {
    right: -150,
  },
  [theme.breakpoints.down(720)]: {
    display: "none",
  },
}));
const ImageFour = styled("img")(({ theme }) => ({
  position: "absolute",
  bottom: 0,
  right: -120,
  [theme.breakpoints.down(1200)]: {
    right: -40,
  },
  [theme.breakpoints.down(900)]: {
    right: -90,
  },
  [theme.breakpoints.down(720)]: {
    display: "none",
  },
}));

const CtaButton = styled("button")(({ theme }) => ({
  background: "linear-gradient(to bottom, #FDD649 0%, #97802C 100%)",
  padding: "8px 32px",
  color: "#FEFEFE",
  borderRadius: 20,
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginTop: 40,
  fontSize: "1rem",
  lineHeight: "1.5rem",
  "&:hover": {
    background: "#97802C",
  },
  [theme.breakpoints.down(720)]: {
    justifyContent: "center",
    marginTop: 0,
  },
}));

const MainText = styled("div")(({ theme }) => ({
  width: "874px",
  margin: "auto",
  position: "relative",
  height: "100%",
  [theme.breakpoints.down(600)]: {
    width: "100%",
  },
  [theme.breakpoints.down(900)]: {
    maxWidth: "570px",
    width: "100%",
  },
  "&>h1": {
    color: "#fefefe",
    fontWeight: 700,
    fontSize: "4rem",
    textAlign: "center",
    lineHeight: "5.423125rem",
    textTransform: "capitalize",
    width: "760px",
    margin: "auto",
    [theme.breakpoints.down(1025)]: {
      width: "570px",
      fontSize: "3rem",
      lineHeight: "3.828125rem",
    },
    [theme.breakpoints.down(900)]: {
      width: "100%",
    },
    [theme.breakpoints.down(720)]: {
      fontSize: "2.25rem",
      lineHeight: "3.05875rem",
      width: "100%",
    },
  },
}));

const CtaBtnBox = styled("div")(({ theme }) => ({
  margin: "4px 0 0px 0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "20px",

  [theme.breakpoints.down(720)]: {
    marginTop: "20px",
    width: "100%",
    flexDirection: "column",
  },
}));

const PaperHeadText = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: "1.25rem",
  lineHeight: "2rem",
  margin: "auto",
  textAlign: "center",
  marginTop: 20,
  color: "#fefefe",
  width: 712,

  [theme.breakpoints.down(720)]: {
    fontSize: "1rem",
    lineHeight: "1.5rem",
    width: 300,
    marginTop: 16,
  },

  [theme.breakpoints.down(320)]: {
    width: "100%",
  },

  [theme.breakpoints.down(900)]: {
    width: "100%",
  },
}));
